export const seoData = {
  "/": {
    title: "MSMB - Malta School of medicine & Business",
    description: "MSMB - Malta School of medicine & Business",
    keywords: "Malta, medicine, business, education",
  },
  "/single-page/about-university": {
    title:
      "МАЛЬТИЙСКИЙ УНИВЕРСИТЕТ|МАЛЬТИЙСКАЯ ШКОЛА БИЗНЕСА И МЕДИЦИНЫ|УЧЕБА НА МАЛЬТЕ|ВЫСШЕЕ ОБРАЗОВАНИЕ В ЕВРОПЕ",
    description:
      "Мальтийский университет с международными программами обучения. Получите качественное европейское образование на английском языке в самом сердце Европы — на Мальте.",
    keywords:
      "Университет на Мальте, образование в Европе, Malta university, высшее образование за границей.",
  },
  "/single-page/our-advantages": {
    title:
      "ПОЧЕМУ ВЫБРАТЬ УЧЕБУ НА МАЛЬТЕ|ПРЕИМУЩЕСТВА ЕВРОПЕЙСКОГО ОБРАЗОВАНИЯ| УЧИТЬСЯ В ЕВРОПЕ — ПЛЮСЫ|СТОИТ ЛИ ЕХАТЬ УЧИТЬСЯ НА МАЛЬТУ|MALTA EDUCATION BENEFITS|ОБРАЗОВАНИЕ В ЕС ДЛЯ ИНОСТРАНЦЕВ",
    description:
      "Качественное образование, практика за рубежом, поддержка студентов и актуальные программы обучения.",
    keywords: "",
  },
  "/single-page/campus": {
    title:
      "КАМПУС НА МАЛЬТЕ|УЧЕБА С ПРОЖИВАНИЕМ НА МАЛЬТЕ |УНИВЕРСИТЕТСКОЕ ЖИЛЬЕ МАЛЬТА|СТУДЕНЧЕСКАЯ ЖИЗНЬ В ЕВРОПЕ|MALTA UNIVERSITY CAMPUS|STUDY AND LIVE IN MALTA",
    description:
      "Почему студенты выбирают учебу на Мальте: доступное образование, международные дипломы, обучение на английском языке и безопасная европейская страна.",
    keywords: "Плюсы учебы в Европе, преимущества учебы за границей, мальта образование",
  },
  "/programs/education-medical": {
    title:
      "МЕДИЦИНСКОЕ ОБРАЗОВАНИЕ В ЕВРОПЕ|ГДЕ УЧИТЬСЯ НА ВРАЧА ЗА ГРАНИЦЕЙ МАЛЬТА МЕДИЦИНСКИЙ УНИВЕРСИТЕТ|УЧЕБА НА ВРАЧА В ЕС|STUDY MEDICINE IN MALTA|AFFORDABLE MEDICAL SCHOOLS IN EUROPE",
    description:
      "Медицинское образование в Европе. Учитесь на врача в аккредитованном университете на Мальте. Англоязычные программы с практикой в клиниках.",
    keywords: "Медицинский университет в Европе, учёба на врача, study medicine Malta",
  },
  "/programs/education-arch": {
    title:
      "АРХИТЕКТУРА В ЕВРОПЕ|ИНЖЕНЕРНОЕ ОБРАЗОВАНИЕ ЗА ГРАНИЦЕЙ|УЧЕБА НА АРХИТЕКТОРА В ЕС|ТЕХНИЧЕСКИЕ ВУЗЫ ЕВРОПЫ|ENGINEERING IN MALTA|ARCHITECTURE STUDIES EUROPE",
    description:
      "Инженерное и архитектурное образование в ЕС. Изучайте проектирование, строительство и современные технологии в университете на Мальте.",
    keywords:
      "Архитектура за границей, инженерное образование Европа, архитектурный факультет мальта",
  },
  "/programs/education-business": {
    title:
      "БИЗНЕС-ШКОЛА НА МАЛЬТЕ|ГДЕ УЧИТЬСЯ НА БИЗНЕСМЕНА В ЕВРОПЕ|МЕНЕДЖМЕНТ И ЭКОНОМИКА ЗА ГРАНИЦЕЙ|MALTA BUSINESS SCHOOL|BUSINESS EDUCATION EUROPE|MBA MALTA",
    description:
      "Бизнес-образование в Европе. Получите диплом в сфере менеджмента, экономики и предпринимательства в международной бизнес-школе на Мальте.",
    keywords:
      "Бизнес школа мальта, обучение менеджменту в европе, экономическое образование за границей",
  },
  "/programs/education-technology": {
    title:
      "IT ОБРАЗОВАНИЕ В ЕВРОПЕ|ГДЕ УЧИТЬСЯ НА ПРОГРАММИСТА ЗА ГРАНИЦЕЙ|УЧЕБА В СФЕРЕ ТЕХНОЛОГИЙ МАЛЬТА|COMPUTER SCIENCE EUROPE|STUDY IT IN MALTA / BEST TECH PROGRAMS EUROPE",
    description:
      "Современные программы по IT, программированию, кибербезопасности и аналитике данных. Учитесь в Европе — дистанционно или на кампусе.",
    keywords: "IT образование в Европе, обучение программированию, it университет мальта",
  },
  "/programs/education-sciences": {
    title:
      "ПСИХОЛОГИЯ ЗА ГРАНИЦЕЙ|СОЦИАЛЬНЫЕ НАУКИ В ЕВРОПЕ|ГУМАНИТАРНЫЕ ФАКУЛЬТЕТЫ В ЕС|STUDY HUMANITIES IN MALTA|SOCIAL SCIENCES EUROPE|PSYCHOLOGY MALTA UNIVERSITY",
    description:
      "Психология, коммуникации, социология и другие гуманитарные дисциплины в европейском вузе. Получите диплом, признанный по всему миру.",
    keywords:
      "Гуманитарное образование за границей, социальные науки мальта, факультет психологии европа",
  },
  "/programs/education-law": {
    title:
      "ГДЕ УЧИТЬСЯ НА ЮРИСТА В ЕВРОПЕ|ПРАВО В ЕС ДЛЯ ИНОСТРАНЦЕВ|ЮРИДИЧЕСКОЕ ОБРАЗОВАНИЕ МАЛЬТА|LAW STUDIES IN ENGLISH EUROPE|STUDY LAW IN MALTA|LEGAL EDUCATION EUROPE",
    description:
      "Юридическое образование по международным стандартам. Получите диплом юриста, обучаясь на английском в Европе — в университете на Мальте.",
    keywords: "Право в европе, обучение юриспруденции за границей, юридический факультет мальта",
  },
  "/single-page/admission-process-full-time": {
    title:
      "КАК ПОСТУПИТЬ В ВУЗ НА МАЛЬТЕ|УЧЕБА В ЕВРОПЕ ОЧНО|ОЧНОЕ ОБУЧЕНИЕ ЗА ГРАНИЦЕЙ| STEP-BY-STEP ADMISSION MALTA|FULL-TIME STUDIES MALTA|КАК НАЧАТЬ УЧЕБУ В ЕС",
    description:
      "Пошаговый процесс поступления на очное обучение в вуз на Мальте. Подайте документы онлайн и начните учиться в Европе на кампусе.",
    keywords: "Поступление мальта, очное обучение европа, как поступить за границу",
  },
  "/single-page/admisision-process-distance-learning": {
    title:
      "ОНЛАЙН-ОБРАЗОВАНИЕ В ЕВРОПЕ|ДИСТАНЦИОННЫЙ УНИВЕРСИТЕТ МАЛЬТА|УЧЕБА ЗА ГРАНИЦЕЙ ОНЛАЙН|ONLINE DEGREE MALTA|DISTANCE LEARNING EUROPE|AFFORDABLE ONLINE UNIVERSITY",
    description:
      "Поступить на дистанционную программу в европейский вуз легко. Учитесь из любой страны, получая международный диплом.",
    keywords: "Дистанционное обучение европа, онлайн университет мальта, поступление онлайн",
  },
  "/single-page/modern-pedagogical-technologies": {
    title:
      "НОВЫЕ МЕТОДЫ ПРЕПОДАВАНИЯ|EDTECH ИНСТРУМЕНТЫ ДЛЯ УЧИТЕЛЕЙ|ИННОВАЦИИ В ОБРАЗОВАНИИ|DIGITAL LEARNING TOOLS 2025|TEACHING INNOVATIONS|ПЕДАГОГИКА БУДУЩЕГО",
    description:
      "Курсы для преподавателей по новым методам обучения, blended learning, активным форматам и цифровым инструментам в образовании.",
    keywords: "Современные методы преподавания, курсы для педагогов, обучение edtech",
  },
  "/single-page/digitization-and-edtech": {
    title:
      "EDTECH В ВУЗАХ|ЦИФРОВОЕ ОБРАЗОВАНИЕ ЕВРОПА|ОБРАЗОВАТЕЛЬНЫЕ ТЕХНОЛОГИИ 2025 / ОНЛАЙН-ПЛАТФОРМЫ ДЛЯ ПРЕПОДАВАНИЯ|DIGITAL TRANSFORMATION EDUCATION|EDTECH EUROPE",
    description:
      "Обучение EdTech-инструментам, цифровым платформам и онлайн-обучению. Курсы повышения квалификации для вузов и школ.",
    keywords: "Edtech курсы, цифровизация образования, онлайн инструменты для преподавателей",
  },
  "/single-page/international-cooperation-and-internationalization": {
    title:
      "АКАДЕМИЧЕСКАЯ МОБИЛЬНОСТЬ ЕВРОПА|ОБМЕН СТУДЕНТАМИ МАЛЬТА|ERASMUS МАЛЬТА|МЕЖДУНАРОДНЫЕ ВУЗЫ С ПРОГРАММАМИ ОБМЕНА|GLOBAL EDUCATION PARTNERSHIPS|INTERNATIONAL COOPERATION MALTA",
    description:
      "Участие в Erasmus+ и других международных проектах. Обмен студентами и преподавателями, партнёрства с университетами Европы.",
    keywords: "Академическая мобильность, erasmus мальта, международные программы вуз",
  },
  "/single-page/quality-and-academic-integrity": {
    title:
      "КАЧЕСТВО ОБРАЗОВАНИЯ ЕВРОПА|АКАДЕМИЧЕСКАЯ ЧЕСТНОСТЬ В ВУЗАХ|ETHICAL EDUCATION EUROPE / ЧЕСТНОЕ ОБУЧЕНИЕ ЗА ГРАНИЦЕЙ|INTEGRITY IN EDUCATION|UNIVERSITY STANDARDS EUROPE",
    description:
      "Программы повышения квалификации по академической честности, этике, качеству преподавания и прозрачности в вузах.",
    keywords: "Академическая честность, качество образования, университетские стандарты европа",
  },
  "/single-page/medicine-and-healthcare": {
    title:
      "КУРСЫ ДЛЯ ВРАЧЕЙ В ЕВРОПЕ|ПОВЫШЕНИЕ КВАЛИФИКАЦИИ В МЕДИЦИНЕ|МЕДИЦИНСКИЕ СЕМИНАРЫ МАЛЬТА|HEALTHCARE TRAINING ABROAD|MEDICAL CPD EUROPE|HEALTHCARE COURSES MALTA",
    description:
      "Курсы повышения квалификации для врачей, медсестёр и специалистов здравоохранения. Мальта — европейский опыт и практика.",
    keywords: "Повышение квалификации врачей, курсы медицина европа, обучение для медработников",
  },
  "/single-page/soft-skills-and-resources-of-the-teachet": {
    title:
      "SOFT SKILLS ДЛЯ ПЕДАГОГОВ|ПРОФЕССИОНАЛЬНОЕ РАЗВИТИЕ ПРЕПОДАВАТЕЛЯ|КАК СТАТЬ ЭФФЕКТИВНЫМ ПРЕПОДАВАТЕЛЕМ|НАВЫКИ XXI ВЕКА|TEACHER GROWTH TRAINING|PERSONAL RESOURCES FOR EDUCATORS",
    description:
      "Soft skills, эмоциональный интеллект и профессиональное выгорание. Курсы личной устойчивости для преподавателей.",
    keywords: "Мягкие навыки педагога, развитие преподавателя, профессиональная устойчивость",
  },
  "/single-page/english-for-career-and-international-communication": {
    title:
      "АНГЛИЙСКИЙ ДЛЯ РАБОТЫ ЗА ГРАНИЦЕЙ|БИЗНЕС-АНГЛИЙСКИЙ ОНЛАЙН|ENGLISH FOR CAREER|ENGLISH FOR INTERNATIONAL COMMUNICATION|АНГЛИЙСКИЙ В ЕВРОПЕ|IMPROVE ENGLISH FOR JOB ABROAD",
    description:
      "Английский язык для работы, международной карьеры и академического общения. Курсы на Мальте или онлайн.",
    keywords: "Английский для карьеры, english for professionals, деловой английский мальта",
  },
  "/single-page/innovation-and-project-thinking-in-higher-education": {
    title:
      "ИННОВАЦИИ В ВУЗАХ|ПРОЕКТНОЕ МЫШЛЕНИЕ В ОБРАЗОВАНИИ|DESIGN THINKING ДЛЯ ПРЕПОДАВАТЕЛЕЙ|НОВЫЕ ФОРМАТЫ ОБУЧЕНИЯ|EDUCATION INNOVATION EUROPE",
    description:
      "Инновационные практики, проектная деятельность, дизайн-мышление для вузов. Курсы для преподавателей и методистов.",
    keywords: "Инновации в образовании, проектное мышление вуз, обучение преподавателей европа",
  },
  "/single-page/education-personal": {
    title:
      "Очное обучение в Европе|Университет на Мальте очно|Учёба за границей на кампусе|Full-time university Europe",
    description:
      "Получите высшее образование на Мальте по очной форме. Учитесь в кампусе с современной инфраструктурой, в международной академической среде. ",
    keywords:
      "Очное обучение за границей, университет на Мальте, campus study Europe, высшее образование очно",
  },
  "/single-page/education-remotely": {
    title:
      "Онлайн-обучение в Европе|Дистанционное образование Мальта|Университет онлайн|Study online in Europe",
    description:
      "Удобная дистанционная форма обучения с международным дипломом. Учитесь онлайн из любой точки мира в европейском университете на английском языке.",
    keywords:
      "Дистанционное обучение мальта, онлайн вуз европа, учёба за границей онлайн, online university degree точки мира в европейском университете на английском языке.",
  },

  default: {
    title: "MSMB - Malta School of medicine & Business",
    description: "MSMB - Malta School of medicine & Business",
    keywords: "Malta, medicine, business, education",
  },
};
